<template>
    <div>
        <bar :options="options" :data="data"/>
    </div>
</template>

<script>
// eslint-disable-next-line
import { Bar } from 'vue-chartjs';
// eslint-disable-next-line
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'BarChart',
    components: { Bar },
    props: {
        data: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
};
</script>
